<template>
  <div>
    <el-dialog
      title="模版设置"
      :visible.sync="dialog"
      width="60%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="data" label-width="80px" :rules="rules">
        <el-form-item label="模版名称" prop="name">
          <el-input v-model="data.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="模版类型" prop="type_id">
          <el-select
            v-model="data.type_id"
            placeholder="请选择"
            clearable
            size="mini"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="模版内容" prop="content">
          <el-input
            v-model="data.content"
            placeholder="请输入"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">保存</el-button>
          <el-button @click="handleClose()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SmsTemplateView",
  props: {
    id: {
      type: Number,
      default: null,
    },
    mode: {
      type: String,
      default: "add",
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      data: {
        name: "",
        type_id: "",
        content: "",
      },
      rules: {
        name: [{ required: true, message: "请输入模版名称", trigger: "blur" }],
        type_id: [
          { required: true, message: "请选择模版类型", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入模版内容", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    id(n) {
      if (this.mode == "edit") {
        this.getTemplateView(n);
      }
    },
    mode(n, o) {
      if (n == "add") {
        this.data = {
          name: "",
          type_id: "",
          content: "",
        };
      }
    },
  },
  mounted() {
  },
  methods: {
    getTemplateView(id) {
      this.$myhttp
        .post(
          "admin/SmsTemplate/getTemplateView",
          { id },
          { "Content-Type": "application/x-www-form-urlencoded" }
        )
        .then((res) => {
          // 异步执行成功后
          this.data = res.data.data;
        });
    },
    handleClose() {
      this.$emit("close", false);
    },
    handleSave() {
      this.$emit("save", null);
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$myhttp
            .post("admin/SmsTemplate/saveTemplate", this.data, {
              "Content-Type": "application/x-www-form-urlencoded",
            })
            .then((res) => {
              // 异步执行成功后
              if (res.data.code == 200) {
                this.$message.success("保存成功");
                this.handleClose();
                this.handleSave();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Admin/Butler/SmsTemplateView.vue